import axios from "axios";

export const LAMKA_API = process.env.REACT_APP_LAMKA_API;
const TOKEN_KEY = "lamka_session_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: LAMKA_API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const BEAUTY_CAT = "Beauty +";
export const FASHION_CAT = "Fashion";

const PATH_KEYS = ["path", "url", "image", "key", "file", "image_url"];

export const normalizeImageRef = (ref) => {
  let p = ref && typeof ref === "object" ? PATH_KEYS.map((k) => ref[k]).find((v) => typeof v === "string") : ref;
  if (typeof p !== "string") return null;
  p = p.trim();
  if (!p) return null;
  if (p.startsWith("data:")) return p;
  const filesAt = p.indexOf("/files/");
  if (/^https?:\/\//i.test(p)) {
    if (filesAt === -1 || !p.includes("/api/files/")) return p;
    return decodeURIComponent(p.slice(p.indexOf("/api/files/") + "/api/files/".length).split(/[?#]/)[0]);
  }
  p = p.replace(/^\/+/, "").replace(/^(api\/)?files\/+/, "");
  return p || null;
};

export const imageUrl = (ref) => {
  const path = normalizeImageRef(ref);
  if (!path) return null;
  if (/^https?:\/\//i.test(path) || path.startsWith("data:")) return path;
  return `${LAMKA_API}/files/${path}`;
};

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

export const THRIFT_CAT = "Thrift";
export const KIDS_TAG = "#Kids";
export const KIDS_AGES = ["0-2", "3-5", "6-10", "11-14"];
export const ageLabel = (a) => `${a.replace("-", "–")} yrs`;
const AGE_RE = /(^|\s)#age(\d{1,2}-\d{1,2})(?=\s|$)/i;
export const ageOf = (desc) => (desc || "").match(AGE_RE)?.[2] || null;
export const withAgeTag = (desc, age) => {
  const base = (desc || "").replace(new RegExp(AGE_RE.source, "gi"), "$1").trim();
  return age ? `${base} #Age${age}`.trim() : base;
};
const KIDS_RE = /(^|\s)#kids(?=\s|$)/i;
export const isKidsThrift = (item) => KIDS_RE.test(item.description || "");
export const hasKidsTag = (desc) => KIDS_RE.test(desc || "");
export const withKidsTag = (desc, on) => {
  const base = withAgeTag((desc || "").replace(/(^|\s)#kids(?=\s|$)/gi, "$1"), on ? ageOf(desc) : null).trim();
  if (!on) return base;
  return base ? `${base}\n\n${KIDS_TAG}` : KIDS_TAG;
};

export async function fetchThrift() {
  const { data } = await api.get("/listings", { params: { category: THRIFT_CAT, closet: true } });
  return data
    .filter((l) => l.active !== false && l.category === THRIFT_CAT)
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
}

export async function fetchBeautyFashion() {
  const [b, f] = await Promise.all([
    api.get("/listings", { params: { category: BEAUTY_CAT } }),
    api.get("/listings", { params: { category: FASHION_CAT } }),
  ]);
  return [...b.data, ...f.data]
    .filter((l) => l.active !== false && [BEAUTY_CAT, FASHION_CAT].includes(l.category))
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
}
